import { useEffect, useRef, useState } from 'react'
import { navigate } from '../lib/router'
import { useHozzajarulas, valasz } from '../lib/consent'
import { pixelBeallitva } from '../lib/metaPixel'
import { CookieIcon } from './icons'

/**
 * HOZZAJARULASI PANEL.
 *
 * ────────────────────────────────────────────────────────────────────
 * AMIT EZ A PANEL NEM CSINAL
 *
 * Nem takarja el az oldalt, nem fogja meg a billentyuzetet, es nincs
 * benne "X" gomb. Mindharom szandekos:
 *
 *   - Az elzart oldal a valasztast KENYSZERRE valtja: aki tovabb akar
 *     olvasni, ravag az elfogadasra. Az igy szerzett kattintas nem
 *     "onkentes" (GDPR 4. cikk 11. pont), tehat semmit nem er.
 *   - A bezaro "X" a legrosszabb megoldas: se nem elfogadas, se nem
 *     elutasitas, a panel megis eltunik - a latogato ugy jar tovabb az
 *     oldalon, hogy azt hiszi, dontott.
 *
 * Ket gomb van, EGYFORMA merettel es egyforma tavolsagra: egy kattintas
 * az elfogadas, egy kattintas az elutasitas. A narancs kiemeles
 * megengedett, az ELERHETOSEGUK viszont azonos.
 *
 * ────────────────────────────────────────────────────────────────────
 * MIERT NEM VESZI EL A FOKUSZT
 *
 * A panel a fa ELEJEN all, tehat billentyuzettel az elso Tab mar ide
 * hoz. Ennel tobbet nem teszunk: aki epp olvas vagy urlapot tolt ki,
 * annak a fokusza ne ugorjon el egy sav miatt, ami nem is surgos.
 * ────────────────────────────────────────────────────────────────────
 */
export default function ConsentBanner(): JSX.Element | null {
  const { kerdezzunk, marketing } = useHozzajarulas()
  const panel = useRef<HTMLDivElement>(null)

  /*
    ────────────────────────────────────────────────────────────────────
    OSSZECSUKVA INDUL: EGY SUTI-KARIKA A SAROKBAN

    A teljes sav 375x812-es keszuleken 267 pixel - a kepernyo harmada. Az
    arbecsles nyito kepernyojen pontosan azzal a feltoltessel versenyzett,
    amiert a latogato odaert.

    A karika ~48 pixel, es a panel BELOLE nyilik ki (a mozgas neve
    „origin-aware animation": a transform-origin a karikan al, tehat a sav
    lathatoan onnan no ki, nem a semmibol jelenik meg).

    AMI NEM VALTOZOTT, ES NEM IS SZABAD:
      - nincs „X" gomb. A karika nem bezar, hanem VISSZACSUK - a valasztas
        tovabbra is a ket egyenrangu gomb, es a karika ott marad;
      - a panel most sem takarja el az oldalt, es nem fogja meg a
        fokuszt (lasd a fenti bekezdeseket);
      - a ket gomb merete es tavolsaga valtozatlanul azonos.

    A meres alapbol aktiv, a kis karika pedig minden oldalon megmarad,
    hogy a latogato egy kattintassal elerje es kikapcsolhassa.
    ────────────────────────────────────────────────────────────────────
  */
  const [nyitva, setNyitva] = useState(false)

  /*
    ────────────────────────────────────────────────────────────────────
    AZ ÚJRANYITÁS KINYITJA A PANELT - KÜLÖNBEN ELROMLANA A VISSZAVONÁS

    A `/sutik` oldalon all egy „Süti-beállítások módosítása" gomb
    (`panelUjranyitasa`), es a GDPR 7. cikk (3) miatt ez nem dekoracio: a
    visszavonasnak ugyanolyan konnyunek kell lennie, mint a megadasnak.

    Az ikon most minden dontes utan is lathato marad. A lablec gombja ugy
    mukodik, hogy a `kerdezzunk` erteket ujra igazza teszi; ettol a mar
    jelen levo ikonhoz tartozo panelnek azonnal ki is kell nyilnia.

    Ezert nem az erteket nezzuk, hanem a VALTAST: ha a `kerdezzunk` hamisrol
    igazra fordul, azt az ujranyitas okozta - az elso latogatasnal ugyanis
    mar a legelso rendereleskor igaz, tehat nincs atmenet.
    ────────────────────────────────────────────────────────────────────
  */
  const elozoKerdezzunk = useRef(kerdezzunk)
  useEffect(() => {
    if (kerdezzunk && !elozoKerdezzunk.current) setNyitva(true)
    elozoKerdezzunk.current = kerdezzunk
  }, [kerdezzunk])

  /*
    ────────────────────────────────────────────────────────────────────
    A SAV HELYET FOGLAL MAGANAK - KULONBEN LETAKAR EGY GOMBOT

    Ez nem elmeleti kockazat, hanem mert eset: 375x812-es kepernyon a
    panel 267 pixel magas, es amikor a latogato az arbecslo varazslo
    aljara gorget, PONTOSAN a Tovabb gomb kerul ala. A gomb latszik, de a
    kattintas a savot talalja el - a folyamat egyszeruen megall, es a
    latogato nem tudja, miert.

    A megoldas nem az, hogy a sav kisebb legyen (a szoveg attol meg
    ugyanannyi), hanem hogy a lap ALJA nojon meg pont annyival, amennyit
    a sav elfoglal. A magassagot MERJUK, nem talaljuk ki: a szoveg
    hossza, a betumeret es a kepernyoszelesseg is valtoztat rajta.

    A `ResizeObserver` a kepernyoforgatast es a betumeret-valtoztatast is
    lekoveti. Ahol nincs (regi bongeszo, teszt), az egyszeri meres marad -
    az is jobb, mint a semmi.
    ────────────────────────────────────────────────────────────────────
  */
  useEffect(() => {
    const elem = panel.current
    if (!elem) return

    const gyoker = document.documentElement
    let utolso = -1

    /*
      A VALTOZATLAN ERTEKET NEM IRJUK KI.

      A kiirt ertek a lap also behuzasat allitja, az pedig ujabb
      atrendezest okoz. Ha minden korben irnank, a `ResizeObserver`
      sajat magat etetne - a bongeszo ilyenkor eldobja a tovabbi
      ertesiteseket, es az ertek BERAGAD. Pontosan ez tortent:
      1002 pixel maradt bent egy 123 pixeles sav mellett.
    */
    const meres = (): void => {
      const magas = Math.ceil(elem.getBoundingClientRect().height)
      if (magas === utolso || magas === 0) return
      utolso = magas
      gyoker.style.setProperty('--vx-consent-h', `${magas}px`)
    }

    document.body.classList.add('vx-consent-open')

    /*
      ────────────────────────────────────────────────────────────────
      AZ ELSO MERES NEM AZONNAL, ES NEM IS EGYETLEN PROBALKOZAS

      Ket dolog is elronthatja a legelso merest:

        - fejlesztes kozben a stiluslapot a Vite JavaScriptbol fuzi be,
          tehat a hatas lefutasakor a sav meg stilus nelkul all -
          ilyenkor tobbszoros magassagot mernenk (merve: 1002 pixel egy
          123 pixeles sav helyett);
        - a hatas lefutasakor a sav meg egyaltalan nincs kimerve, es
          nullat ad vissza - ez tortent az elso valtozatnal, ezert az
          ertek beallitatlan maradt egeszen az elso ablakmeret-valtasig.

      Ezert nulla magassagot NEM fogadunk el vegeredmenynek, hanem par
      kepkockan at ujraprobalunk. Tiz kepkocka utan feladjuk: ha addig
      sem lett merheto, akkor a sav ugysem latszik.
      ────────────────────────────────────────────────────────────────
    */
    let keret = 0
    let festesElottiKeret = 0
    let proba = 0
    const ujraprobal = (): void => {
      keret = requestAnimationFrame(() => {
        const magas = Math.ceil(elem.getBoundingClientRect().height)
        if (magas > 0) {
          meres()
          return
        }
        if (++proba < 10) ujraprobal()
      })
    }
    /*
      Preact alatt a hatas mar az elso bongeszo-layout elott is lefuthat.
      Egyetlen rAF callbackben a `getBoundingClientRect()` ilyenkor az egesz
      hosszu fooldal szinkron elrendezeset kikényszeritene, ami hosszu fo-szali
      feladatkent jelenik meg. A kulso rAF atengedi az elso festest; a belso
      mar egy kesz elrendezest olvas, igy nem hoz letre kenyszeritett reflow-t.
    */
    festesElottiKeret = requestAnimationFrame(() => ujraprobal())

    const figyelo =
      typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(meres)
    figyelo?.observe(elem)

    /*
      Tartalek azoknak a bongeszoknek, ahol nincs `ResizeObserver`, es
      biztositek a keso betoltodo betutipusra (a sav magassaga a
      sortoressel egyutt valtozik).
    */
    window.addEventListener('resize', meres)
    window.addEventListener('load', meres)

    /*
      HATTERBEN NYITOTT FÜL.

      A `requestAnimationFrame` rejtett lapon NEM fut le - a bongeszo nem
      rajzol, tehat nincs kepkocka. Egy hatterben megnyitott linknel ezert
      a meres elmaradna, es a hely csak az elso ablakmeret-valtaskor
      keletkezne meg. Amikor a fül elore kerul, ez a figyelo pótolja.

      (Ez nem elmeleti eset: pontosan ebbe futott bele a fejlesztoi
      ellenorzes is, ahol a lap `visibilityState: hidden` allapotban volt.)
    */
    document.addEventListener('visibilitychange', meres)

    return () => {
      cancelAnimationFrame(keret)
      cancelAnimationFrame(festesElottiKeret)
      figyelo?.disconnect()
      window.removeEventListener('resize', meres)
      window.removeEventListener('load', meres)
      document.removeEventListener('visibilitychange', meres)
      document.body.classList.remove('vx-consent-open')
      gyoker.style.removeProperty('--vx-consent-h')
    }
    /*
      A `nyitva` IS FUGGOSEG. A lefoglalt hely a ket allapotban gyokeresen
      mas (~48px karika vs. ~267px sav), es a `ResizeObserver` ugyan
      eszrevenne a valtozast, de csak a nyitas UTAN - egy kepkockara a regi
      ertek maradna bent. A hatas ujrafuttatasa az elso festessel egyutt
      meri ujra.
    */
  }, [kerdezzunk, nyitva])

  /*
    NINCS PIXEL, NINCS PANEL.

    Ha a `VITE_META_PIXEL_ID` ures, semmilyen marketingmeres nem fut -
    ilyenkor engedelyt kerni ertelmetlen es felrevezeto lenne. Ez teszi
    kapcsolhatova az egesz reteget: egy ures kornyezeti valtozo az
    oldalt pontosan abba az allapotba teszi vissza, ami elotte volt.
  */
  if (!pixelBeallitva) return null

  const megnyit = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return
    event.preventDefault()
    navigate('/sutik')
  }

  const dontes = (ertek: 'megadva' | 'megtagadva'): void => {
    valasz(ertek)
    /* A dontes utan a panel visszacsukodik, az ikon viszont megmarad. */
    setNyitva(false)
  }

  return (
    /*
      NATIV KIEGESZITO LANDMARK, NEM DIALOGUS.

      A sav szandekosan nem modalis: nem zarja el az oldalt, nem tartja
      magaban a fokuszt, es osszecsukhato. Az `<aside>` ehhez eleve a
      megfelelo `complementary` szerepet adja. `role="dialog"` nem adhato
      szabalyosan egy `<aside>` elemnek, az `aria-modal` pedig csak
      `dialog`/`alertdialog` szerep mellett ertelmezett. Ezert egyik ARIA
      feluliras sem kell; a natív szemantika pontosan leirja a mukodest.
    */
    <aside
      className="vx-consent"
      data-open={nyitva ? 'true' : 'false'}
      aria-labelledby="vx-consent-cim"
      aria-describedby="vx-consent-szoveg"
    >
      {/*
        A MERT ELEM A BURKOLO, NEM A PANEL.

        A lap alja annyival no meg, amennyit ez a sav TENYLEGESEN elfoglal -
        osszecsukva a karika, nyitva a teljes panel. Ha a merés a panelre
        lenne kotve, osszecsukott allapotban nem lenne mit merni, es a
        karika ugyanugy ralogna a „Tovabb" gombra, ahogy korabban a sav.
      */}
      <div className="vx-consent__wrap" ref={panel}>
        {/*
          A KARIKA. Nem bezar es nem is dont el semmit - ki- es visszacsuk.

          `aria-expanded` mondja meg a kepernyoolvasonak, mi tortenik, es a
          felirata allapotfuggo: „Süti-beállítások megnyitása" / „…elrejtése".
          Egy puszta „Sütik" felirat itt keveset erne.
        */}
        <button
          type="button"
          className="vx-consent__bubble"
          aria-expanded={nyitva}
          aria-controls="vx-consent-panel"
          aria-label={nyitva ? 'Süti-beállítások elrejtése' : 'Süti-beállítások megnyitása'}
          onClick={() => setNyitva((v) => !v)}
        >
          <CookieIcon size={24} />
        </button>

        {/*
          A PANEL A DOM-BAN MARAD OSSZECSUKVA IS - de `visibility: hidden`
          allapotban (lasd `consent.css`).

          `hidden` attributum vagy `display: none` egyszerubb lenne, csakhogy
          egyik sem animalhato: a kinyilas azonnali ugras lenne, nem a
          karikabol kinovo mozgas. A `visibility` viszont atmenetet is tur, ES
          ugyanugy kiveszi az elemet a tabsorbol es a kepernyoolvasobol, mint
          a `hidden` tenne - tehat osszecsukva senki nem talal bele.
        */}
        <div className="vx-consent__panel" id="vx-consent-panel">
        <div className="vx-consent__copy">
          <h2 className="vx-consent__title" id="vx-consent-cim">
            Mérés a hirdetéseinkhez
          </h2>
          <p className="vx-consent__text" id="vx-consent-szoveg">
            {marketing === 'megadva' ? (
              <>
                A Facebook- és Instagram-hirdetéseink méréséhez a Meta Platforms
                mérőkódját használjuk. A mérés jelenleg aktív. Ha elutasítod,
                azonnal leáll, és a hozzá tartozó bejegyzéseket töröljük.
              </>
            ) : (
              <>
                A Facebook- és Instagram-hirdetések mérése jelenleg ki van kapcsolva.
                Ha elfogadod, a Meta Platforms mérőkódja újra elindul.
              </>
            )}{' '}
            A rendelés minden funkciója a döntésedtől függetlenül működik.{' '}
            <a className="link" href="/sutik" onClick={megnyit}>
              Részletek a süti-tájékoztatóban
            </a>
            .
          </p>
        </div>

        {/*
          A KET GOMB EGY SORBAN, AZONOS MERETBEN.

          Nem "Elfogadom" nagy gomb + "beallitasok" apro link: a
          visszautasitasnak ugyanannyiba kell kerulnie, mint az
          elfogadasnak. A sorrend is szandekos - az elutasitas all
          elol, hogy a hüvelykujj utjaban legyen mobilon is.
        */}
        <div className="vx-consent__actions">
          <button
            type="button"
            className="btn btn--ghost vx-consent__btn"
            onClick={() => dontes('megtagadva')}
          >
            Elutasítom
          </button>
          <button
            type="button"
            className="btn btn--primary vx-consent__btn"
            onClick={() => dontes('megadva')}
          >
            Elfogadom
          </button>
        </div>
        </div>
      </div>
    </aside>
  )
}
